import React, { useRef } from 'react';
import mergeCallbacks from 'utils/ui/mergeCallbacks';
import * as MenuListUI from 'components/MenuList';
import { useMenuContext } from './Menu';
function MenuItem(_ref) {
  var icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    children = _ref.children;
  var itemRef = useRef(null);
  var _useMenuContext = useMenuContext(),
    itemList = _useMenuContext.itemList;
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      text: children,
      value: children,
      disabled: isDisabled
    }),
    id = _itemList$useItem.id,
    select = _itemList$useItem.select,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  return /*#__PURE__*/React.createElement(MenuListUI.Item, {
    ref: itemRef,
    id: id,
    as: "div",
    role: "menuitem",
    "aria-disabled": isDisabled,
    onClick: mergeCallbacks(select, onClick),
    onMouseEnter: highlight,
    onMouseLeave: itemList.clearHighlightedItem
  }, /*#__PURE__*/React.createElement(MenuListUI.Link, {
    forwardedAs: "span",
    isDisabled: isDisabled,
    isHighlighted: useHighlighted()
  }, icon && /*#__PURE__*/React.createElement(MenuListUI.ItemIcon, {
    name: icon
  }), children));
}
export default MenuItem;